/** Extract attached files from a clipboard paste (returns [] when none). */
export function imagesFromClipboard(event: React.ClipboardEvent): File[] {
  return Array.from(event.clipboardData?.items ?? [])
    .filter((item) => item.kind === 'file')
    .map((item) => item.getAsFile())
    .filter((file): file is File => file != null);
}
